/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

export type DataLibraryListItemResponseKind = typeof DataLibraryListItemResponseKind[keyof typeof DataLibraryListItemResponseKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataLibraryListItemResponseKind = {
  variable: 'variable',
  collection: 'collection',
} as const;
